@if (showLoginUsingSso) {
  <div class="row mx-0 px-0 mt-4 justify-content-center align-items-center">
    <span class="col border-bottom w-50"></span>
    <span class="col-auto"> {{ 'login.divider.text' | translate }} </span>
    <span class="col border-bottom w-50"></span>
  </div>
  <cfp-link
    [buttonOutline]="true"
    [buttonStyle]="'secondary'"
    [url]="ssoLoginUrl"
    classes="d-flex w-100 mt-4 align-items-center justify-content-center login-sso-button"
    [dataTest]="'loginAsRelationManager'"
    target="_self"
  >
    <span class="mx-auto">{{ 'login.sso' | translate }}</span>
    <cfp-icon [iconSize]="'large'" [icon]="'angle-right'" />
  </cfp-link>
}
